import React, {useState} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {authAction} from '../../actions/loginAction';
import {connect} from 'react-redux';
import {toast} from 'react-toastify';
import {formatErrors, validateEmail} from '../../constants';
import {InputLogin} from "../../utils/input/InputLogin";

export function Login(props) {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [form, handleChange] = useState({
    email: '',
    password: ''
  });

  const handleChangeForm = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    handleChange({...form, [name]: value});
    setErrors({...errors, [name]: value.trim() === ''});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) {
      return false;
    }
    let errs = {};
    if (form.email === '' || validateEmail(form.email) !== true) {
      errs.email = true;
    }
    if (form.password === '') {
      errs.password = true;
    }

    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      return;
    }

    setLoading(true);
    props.auth(form).then(() => {
      setLoading(false);
      props.history.push('/');
    }).catch(err => {
      setLoading(false);
      switch (err.message) {
        case 'wrong:auth':
          setErrors({email: true, password: true});
          toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
          break;
        default:
          toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      }
    });
  };

  return <div className="auth">
      <form className="auth__wrapper" noValidate onSubmit={handleSubmit}>
        <div className="auth__top">
          <div className="auth__icon" style={{backgroundImage: "url(/img/logo-outline.svg)"}}></div>
          <h3 className="auth__title">Авторизация</h3>
        </div>
        <div className="auth__inner">
          <InputLogin type="email"
                      name="email"
                      placeholder="Введите почту"
                      title="Email адрес"
                      value={form.email}
                      error={errors.email || false}
                      onChange={handleChangeForm}/>

          <InputLogin type="password"
                      name="password"
                      placeholder="Введите пароль"
                      title="Пароль"
                      value={form.password}
                      error={errors.password || false}
                      onChange={handleChangeForm}/>

          <div className="auth__group auth__group--flex">
            <Link to="/restore" className="auth__help auth__help--link">Забыли пароль?</Link>
          </div>
        </div>
        <div className="auth__buttons">
          {/*<Link to="/register" className="auth__link link">Регистрация</Link>*/}
          <button type="submit" className="auth__btn btn" disabled={loading}>Войти</button>
        </div>
        <div className="auth__footer">Название ПО "МенторЛаб"</div>
      </form>
  </div>;
}

const mapStateToProps = (state) => ({
  lang: state.common.lang
});

const mapDispatchToProps = (dispatch) => {
  return {
    auth(data) {
      return dispatch(authAction(data));
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login))
